import * as React from 'react';
import { headingSectionIllustrationPositionContext } from './context';
export function HeadingSectionIllustrationPositionProvider(props) {
    var _a = props.illustrationPosition, illustrationPosition = _a === void 0 ? 'after' : _a, children = props.children;
    return (React.createElement(headingSectionIllustrationPositionContext.Provider, { value: illustrationPosition }, children));
}
